<div class="row">
  <h4 (click)="collapseCapitalGain.toggle()"
      [attr.aria-expanded]="!isSectionCapitalGainCollapsed"
      aria-controls="capitalGain">
    Gain en capital
  </h4>

  <div #collapseCapitalGain="ngbCollapse" [(ngbCollapse)]="isSectionCapitalGainCollapsed">
    <div class="card table-result-card">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'SC'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                Somme convenue
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.agreedAmountForCapitalGain | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'PBR'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                Prix de base rajusté
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.adjustedCostBaseForCapitalGain | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'DIV'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                Dividende (seulement pour une action vendue)
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.deemedDividendForCapitalGain | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'GC'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                Gain en capital
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-description text-end">
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'SC'"></app-output-variable>
                -
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'PBR'"></app-output-variable>
                -
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'DIV'"></app-output-variable>
                =
                {{ propertyTransferredResults.agreedAmountForCapitalGain | currencyCents | notAvailable }}
                -
                {{ propertyTransferredResults.adjustedCostBaseForCapitalGain | currencyCents | notAvailable }}
                -
                {{ propertyTransferredResults.deemedDividendForCapitalGain | currencyCents | notAvailable }}
                =
              </div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.capitalGain | currencyCents | notAvailable }}</div>
            </div>

            <div class="table-result table-result-row table-result-row-indent-0">
              <app-output-variable [selectedBadge]="selectedBadge"
                                   [style]="'primary'" [text]="'GCI'"
                                   class="table-result-col table-result-col-output-variable-badge"></app-output-variable>
              <div class="table-result-col table-result-col-description">
                Gain en capital imposable (Perte en capital déductible)
              </div>
              <div class="table-result-col table-result-col-dots"></div>
              <div class="table-result-col table-result-col-description text-end">
                <app-output-variable [selectedBadge]="selectedBadge" [style]="'primary'"
                                     [text]="'GC'"></app-output-variable>
                x 0.5
                =
              </div>
              <div class="table-result-col table-result-col-value">{{ propertyTransferredResults.taxableCapitalGain | currencyCents | notAvailable }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>